import { api } from "@api/api";
import { DownloadBookMonthlyReport } from "./types";

export async function getDownloadBookMonthlyReportService(
  params?: Record<string, string>
): Promise<DownloadBookMonthlyReport> {
  const { data } = await api.get<DownloadBookMonthlyReport>(
    "v1/download_book_admin/monthly-report/",
    { params }
  );
  return data;
}
